/* eslint-disable prettier/prettier */
import {
  Component,
  OnInit,
  ViewChildren,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import * as dropin from "braintree-web-drop-in";
import * as braintree from 'braintree-web';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { IMyDpOptions } from "mydatepicker";
import { MyDatePicker } from "mydatepicker";
import { DatePipe, formatDate } from "@angular/common";
import { SupportService } from "../services/support-service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
declare var paypal;
@Component({
  selector: "app-credit-card",
  templateUrl: "./credit-card.component.html",
  styleUrls: ["./credit-card.component.scss"],
})
export class CreditCardComponent implements OnInit {
  savecarddetails: FormGroup;
  submitted = false;
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];
  cardType = "";
  invalidcard = false;
  expiryMonthValidation = false;
  expiryYearValidation = false;
  currentDate = new Date();
  cardinfosubmitted = false;
  cardDetails: any = {};
  error: any = [];
  ziplength = 0;
  zipmask = "";
  ziplabel = "";
  phonemask = "00000-00000";
  cardMask = "0000-0000-0000-0000";
  @ViewChildren("expiryyear") expiryyear;
  tccardDetails: any = [];
  isDisable = false;
  deleteCardDetails: any = "";
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;
  @ViewChild("confirmpopup") confirmpopup: TemplateRef<any>;
  @ViewChild("mydp") mydp: MyDatePicker;
  config = {
    ignoreBackdropClick: true,
  };
  modalRef: BsModalRef;
  braintreeIsReady: boolean;
  dropIninstance: any;
  public myDatePickerOptions: IMyDpOptions = {};
  planList: any = "";
  selectedID = "";
  isDisabled = false;
  duration;
  isLoad = false;
  cardLength = 16;
  cvvLength = 3;
  message = "";
  errorMsg = "";
  isDelete = false;
  testCountryCode = "";
  hostedFieldsInstance: any;
  cardholdersName: any;
  getednoncetoken: any;
  client: any;
  constructor(
    private appservice: AppService,
    private ngxservice: NgxUiLoaderService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private datePipe: DatePipe,
    private supportService: SupportService,
    private formBuilder: FormBuilder
  ) {
    const date = new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      editableDateField: false,
      disableSince: { year: year, month: month, day: date.getDate() + 1 },
    };
  }

  ngOnInit() {
    if (localStorage.getItem("pendingCreditCardOnboarding") === "true") {
      this.supportService.isAccept = true;
    }
    this.createForm();
    this.getCountryList();
    this.getCardList();
    this.getPlanList();
    this.viewTestCenter();
    if (
      localStorage.getItem("countryId") !== null &&
      localStorage.getItem("countryId") === "101"
    ) {
      this.ziplength = 6;
      this.zipmask = "000000";
      this.phonemask = "00000-00000";
      this.ziplabel = "Pin code";
    } else if (
      localStorage.getItem("countryId") !== null &&
      localStorage.getItem("countryId") === "231"
    ) {
      this.ziplength = 5;
      this.zipmask = "000000";
      this.phonemask = "(000)000-0000";
      this.ziplabel = "Zip code";
    }
  }


  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            if (this.testCountryCode == "US") {
              this.savecarddetails.controls["dialcode"].setValue("+1");
              this.savecarddetails.controls["countryId"].setValue("231");
              this.changeCountry("231");
            } else {
              this.savecarddetails.controls["dialcode"].setValue("+91");
              this.savecarddetails.controls["countryId"].setValue("101");
              this.changeCountry("101");
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      this.phonemask = this.appservice.checkDialCode(value);
    }
  }

  createForm() {
    this.savecarddetails = this.formBuilder.group({
      username: ["", Validators.required],
      cardnumber: ["", Validators.required],
      type: [{ value: "", disabled: true }],
      expirymonth: ["", [Validators.required, Validators.minLength(2)]],
      expiryyear: ["", Validators.required],
      firstname: ["", Validators.required],
      lastname: ["", Validators.required],
      cvv: ["", [Validators.required, Validators.minLength(3)]],
      countryId: ["", Validators.required],
      addressLine1: ["", Validators.required],
      addressLine2: [""],
      city: ["", Validators.required],
      zip: ["", Validators.required],
      state: ["", Validators.required],
      timezone: [""],
      dob: [""],
      nickName: [""],
      ein: [""],
      dialcode: [""],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      mobileExtn: [""],
      id: [""],
      primaryCard: [false],
    });
  }

  getCountryList() {
    this.appservice.getCountry().subscribe((country) => {
      if (country["status"]["status"]) {
        this.countryList = country["entity"];
      }
    });
  }

  getStateList(countryId) {
    this.appservice.getState(countryId).subscribe((state) => {
      if (state["status"]["status"]) {
        this.stateList = state["entity"];
      }
    });
  }

  getCityList(stateID) {
    this.appservice.getCity(stateID).subscribe((city) => {
      if (city["status"]["status"]) {
        this.cityList = city["entity"];
      }
    });
  }

  changeCountry(input) {
    this.getStateList(input);
    this.savecarddetails.get("zip").setValue(null);
    if (input && input === "101") {
      this.ziplength = 6;
      this.zipmask = "000000";
      this.ziplabel = "Pin code";
    } else if (input && input == "231") {
      this.ziplength = 5;
      this.zipmask = "00000";
      this.ziplabel = "Zip code";
    }
  }

  changeState(input) {
    this.getCityList(input);
  }

  getPlanList() {
    this.appservice
      .getPlanList(localStorage.getItem("testCenterId").toString())
      .subscribe((plan) => {
        if (plan["status"]["status"] === 200) {
          this.isLoad = true;
          this.planList = plan["entity"];
          if (this.planList) {
            this.isDisabled = true;
            const comingdate = new Date(this.planList.expiredDateStr);
            comingdate.setHours(0);
            comingdate.setMinutes(0);
            const currentdate = new Date();
            currentdate.setHours(0);
            currentdate.setMinutes(0);
            this.duration = Math.round(
              (comingdate.getTime() - currentdate.getTime()) /
              (1000 * 3600 * 24)
            );
          }
        } else if (plan["status"]["status"] === 204) {
          this.isLoad = true;
        }
      });
  }

  getCardList() {
    const tcID = localStorage.getItem("testCenterId").toString();
    if (tcID) {
      this.appservice.getcardList(tcID).subscribe((cardlist: any) => {
        if (cardlist.status.status === 200) {
          this.tccardDetails = cardlist.entity;
        }
      });
    }
  }

  onToggleCalendar(event: any): void {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }

  checkziplength(event) {
    if (event && event.length !== this.ziplength) {
      this.ziperror = true;
    } else {
      this.ziperror = false;
    }
  }

  ziperror = false;

  saveCard() {
    this.cardinfosubmitted = true;
    if (this.savecarddetails.invalid) {
      return;
    }
    if (
      this.savecarddetails.get("zip").value &&
      this.savecarddetails.get("zip").value.length != this.ziplength
    ) {
      this.ziperror = true;
      return;
    }
    if (
      this.expiryYearValidation === false &&
      this.expiryMonthValidation === false
    ) {
      this.isDisable = true;
      if (this.savecarddetails.get("id").value) {
        this.addorupdateCard();
      } else {
        const params: any = {
          number: this.savecarddetails.get("cardnumber").value,
          type: this.savecarddetails.get("type").value,
          expire_month: this.chkLength(
            this.savecarddetails.get("expirymonth").value
          ),
          expire_year: this.savecarddetails.get("expiryyear").value,
          first_name: this.savecarddetails.get("firstname").value,
          last_name: this.savecarddetails.get("lastname").value,
          billing_address: {
            line1: this.savecarddetails.get("addressLine1").value,
            city: this.savecarddetails.get("city").value,
            country_code: this.savecarddetails.get("countryId").value,
            postal_code: this.savecarddetails.get("zip").value,
            state: this.savecarddetails.get("state").value,
          },
        };
        // Braintree clientside payment integration
        const creditcarddata = {
          creditCard: {
            number: params.number.toString(),
            expirationMonth: params.expire_month.toString(),
            expirationYear: params.expire_year.toString(),
            cvv: this.savecarddetails.get("cvv").value.toString(),
          },
        }
        let myPromise = new Promise((resolve, reject) => {
          braintree.client.create(
            {
              authorization: environment.Braintreeauth,
            },
            function (err, client) {
              client.request(
                {
                  endpoint: environment.Braintreeurl,
                  method: "post",
                  data: creditcarddata,
                },

                (err: any, response: any) => {
                  // nonce = response.creditCards[0].nonce
                  if (err) {
                    if (err.details.originalError.fieldErrors.length > 0) {
                      err.details.originalError.fieldErrors.map((error: any) => {
                        if (error.field === "creditCard") {
                          reject(error.fieldErrors);
                        }
                      });
                    }
                  } else {
                    let nonce = response.creditCards[0].nonce;
                    resolve(nonce);
                  }
                }
              );
            }
          );
        })
        // Braintree clientside payment integration

        const county = this.countryList.find(
          (c) => c.id === +params.billing_address.country_code
        );
        params.billing_address.country_code = county.countryCode;
        const state = this.stateList.find(
          (s) => s.id === +params.billing_address.state
        );
        params.billing_address.state = state.state;
        params.cvv2 = this.savecarddetails.get("cvv").value;
        this.ngxservice.start();
        myPromise.then((result) => {
          this.getednoncetoken = result;
          this.appservice
            .getaccesstoken(this.testCountryCode)
            .subscribe((token) => {
              if (token && token["access_token"]) {
                this.appservice.savecard(params, token["access_token"]).subscribe(
                  (cardDetail) => {
                    this.addorupdateCard(cardDetail);
                    this.ngxservice.stopAll();
                  },
                  (err) => {
                    this.ngxservice.stopAll();
                    this.cardinfosubmitted = false;
                    this.isDisable = false;
                    this.spinner.hide();
                    this.error = JSON.parse(err._body);
                    if (this.error.details[0].field === "number") {
                      this.errorMsg = "Invalid Card Number";
                      this.clearMessage();
                    } else {
                      this.errorMsg = this.error.details[0].issue;
                      this.clearMessage();
                    }
                    return;
                  }
                );
              }
            })
        }).catch(error => {
          this.toastr.error(error)
        });
      }
    }
  }

  addorupdateCard(cardDetail?: any) {
    let cardParams: any = {};
    cardParams.city = {};
    cardParams.state = {};
    cardParams.country = {};
    cardParams.state.id = this.savecarddetails.get("state").value;
    cardParams.country.id = this.savecarddetails.get("countryId").value;
    const addcardParams: any = {};
    addcardParams.tccardDetails = [];
    if (this.savecarddetails.get("id").value) {
      cardParams = this.savecarddetails.getRawValue();
      cardParams.primaryCard = this.savecarddetails.get("primaryCard").value;
      cardParams.active = true;
      cardParams.deleted = false;
      cardParams.state = {};
      cardParams.country = {};
      cardParams.state.id = this.savecarddetails.get("state").value;
      cardParams.country.id = this.savecarddetails.get("countryId").value;
      cardParams.type = this.savecarddetails.get("type").value;
      cardParams.firstName = this.savecarddetails.get("firstname").value;
      cardParams.lastName = this.savecarddetails.get("lastname").value;
      cardParams.zipCode = this.savecarddetails.get("zip").value;
      cardParams.last4digit = cardParams.cardnumber;
      cardParams.cityName = cardParams.city;
      cardParams.noncetoken = this.getednoncetoken;
      cardParams.cvv = "";
      cardParams.city = {};
      delete cardParams.countryId;
      addcardParams.tccardDetails.push(cardParams);
    } else {
      cardParams.cardRefId = cardDetail.id;
      cardParams.last4digit = cardDetail.number.substr(
        cardDetail.number.length - 4
      );
      cardParams.primaryCard = this.savecarddetails.get("primaryCard").value;
      cardParams.type = cardDetail.type;
      cardParams.expirymonth = cardDetail.expire_month;
      cardParams.expiryyear = cardDetail.expire_year;
      cardParams.cvv = "";
      cardParams.active = true;
      cardParams.deleted = false;
      cardParams.firstName = cardDetail.first_name;
      cardParams.lastName = cardDetail.last_name;
      cardParams.ein = this.savecarddetails.get("ein").value;
      cardParams.timezone = "";
      cardParams.username = this.savecarddetails.get("username").value;
      cardParams.street = "";
      cardParams.addressLine1 = cardDetail.billing_address.line1;
      cardParams.addressLine2 = this.savecarddetails.get("addressLine2").value;
      cardParams.areaName = "";
      cardParams.cityName = this.savecarddetails.get("city").value;
      cardParams.noncetoken = this.getednoncetoken;
      cardParams.nickName = this.savecarddetails.get("nickName").value;
      cardParams.mobileExtn = this.savecarddetails.get("mobileExtn").value;
      cardParams.mobile = this.savecarddetails.get("mobile").value;
      cardParams.dialcode = this.savecarddetails.get("dialcode").value;
      cardParams.zipCode = this.savecarddetails.get("zip").value;
      addcardParams.tccardDetails.push(cardParams);
    }

    cardParams.dob = null;

    this.appservice.addOrUpdateCard(addcardParams).subscribe(
      (card) => {
        if (card["status"]["status"] === 200) {
          this.clearMessage();
          if (this.isOnboardingCreditCardFlow()) {
            this.savePlan();
          } else {
            if (this.savecarddetails.get("id").value) {
              this.errorMsg = "";
              this.message = "Card Saved Successfully";
              this.isDisable = false;
              this.clearMessage();
            }
          }

          setTimeout(() => {
            this.addcard();
          }, 500);

          this.getCardList();
          localStorage.setItem("subscriptionflag", "true");
        } else if (card["status"]["status"] === 400) {
          this.message = "";
          this.errorMsg = "Unable to remove primary card";
          this.isDisable = false;
          this.clearMessage();
        } else {
          this.message = "";
          this.errorMsg =
            card && card["status"] && card["status"]["msg"]
              ? card["status"]["msg"]
              : "Unable to save card. Please check the details and try again";
          this.isDisable = false;
          this.cardinfosubmitted = false;
          this.clearMessage();
        }
      },
      (err) => {
        this.isDisable = false;
        this.cardinfosubmitted = false;
        this.message = "";
        this.errorMsg = "Server Proplem Plz try again";
        this.clearMessage();
      }
    );
  }

  checkCardType(cardNumber) {
    this.cardType = "";
    this.savecarddetails.controls["cardnumber"].clearValidators();
    this.savecarddetails.controls["cardnumber"].setValidators([
      Validators.required,
      Validators.minLength(16),
    ]);
    this.savecarddetails.controls["cvv"].clearValidators();
    this.savecarddetails.controls["cvv"].setValidators([
      Validators.required,
      Validators.minLength(3),
    ]);
    this.cardLength = 16;
    this.cvvLength = 3;
    if (/^(34)|^(37)/.test(cardNumber)) {
      this.cardType = "amex";
      this.savecarddetails.controls["cardnumber"].setValidators([
        Validators.required,
        Validators.minLength(15),
      ]);
      this.savecarddetails.controls["cvv"].setValidators([
        Validators.required,
        Validators.minLength(4),
      ]);
      this.cardLength = 15;
      this.cvvLength = 4;
    }
    // if (/^(62)|^(88)/.test(cardNumber)) {
    //   this.cardType = "China UnionPay";
    // }
    // if (/^30[0-5]/.test(cardNumber)) {
    //   this.cardType = "Diners Club Carte Blanche";
    // }
    // if (/^(2014)|^(2149)/.test(cardNumber)) {
    //   this.cardType = "Diners Club enRoute";
    // }
    // if (/^36/.test(cardNumber)) {
    //   this.cardType = "Diners Club International";
    // }
    if (
      /^(6011)|^(622(1(2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9([01][0-9]|2[0-5])))|^(64[4-9])|^65/.test(
        cardNumber
      )
    ) {
      this.cardType = "discover";
    }
    if (/^35(2[89]|[3-8][0-9])/.test(cardNumber)) {
      this.cardType = "jcb";
    }
    // if (/^(6304)|^(6706)|^(6771)|^(6709)/.test(cardNumber)) {
    //   this.cardType = "Laser";
    // }
    if (
      /^(5018)|^(5020)|^(5038)|^(5893)|^(6304)|^(6759)|^(6761)|^(6762)|^(6763)|^(0604)/.test(
        cardNumber
      )
    ) {
      this.cardType = "maestro";
    }
    if (/^5[1-5]/.test(cardNumber)) {
      this.cardType = "mastercard";
    }
    if (/^4/.test(cardNumber)) {
      this.cardType = "visa";
    }
    if (!this.savecarddetails.get("id").value) {
      this.savecarddetails.controls["type"].setValue(this.cardType);
    }
    if (this.cardType) {
      this.savecarddetails.controls.type.enable();
      this.invalidcard = false;
    } else if (this.cardType === "") {
      this.savecarddetails.controls.type.disable();
      this.invalidcard = true;
    }
    if (this.savecarddetails.get("id").value) {
      this.savecarddetails.controls.type.enable();
      this.invalidcard = false;
    }
    this.savecarddetails.get("cardnumber").updateValueAndValidity();
    this.savecarddetails.get("cvv").updateValueAndValidity();
  }

  focusyeartextbox(value) {
    if (+value > 12) {
      this.expiryMonthValidation = true;
    } else {
      this.expiryMonthValidation = false;
    }
    this.checkMonth();
  }

  expiryyeartextbox(value) {
    const fast = this.currentDate.getFullYear() + 50;
    if (+value >= +this.currentDate.getFullYear() && +value <= fast) {
      this.expiryYearValidation = false;
    } else {
      this.expiryYearValidation = true;
    }
    this.checkMonth();
  }

  checkMonth() {
    const year = +this.savecarddetails.controls["expiryyear"].value;
    const month = +this.savecarddetails.controls["expirymonth"].value;
    if (year && month) {
      if (this.currentDate.getFullYear() === year) {
        if (month >= this.currentDate.getMonth() + 2) {
          this.savecarddetails.controls["expirymonth"].clearValidators();
          this.savecarddetails.controls["expirymonth"].setValidators([
            Validators.required,
            Validators.minLength(2),
          ]);
        } else {
          this.savecarddetails.controls["expirymonth"].setErrors({
            pastDate: true,
          });
        }
      }
    }
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addcard() {
    window.scroll(0, 0);
    this.savecarddetails.reset();
    this.cardinfosubmitted = false;
    this.isDisable = false;
    this.savecarddetails.reset();
    this.savecarddetails.controls["dialcode"].setValue("+91");
    this.savecarddetails.controls["id"].setValue("");
    this.savecarddetails.controls["countryId"].setValue("");
    this.savecarddetails.controls["state"].setValue("");
    this.savecarddetails.controls["city"].setValue("");
    this.savecarddetails.controls["cardnumber"].enable();
    this.savecarddetails.controls["expirymonth"].enable();
    this.savecarddetails.controls["expiryyear"].enable();
    this.savecarddetails.controls["cvv"].enable();
  }

  editCard(card) {
    this.appservice.getCardByID(card.id).subscribe((cardDetail: any) => {
      if (cardDetail.status.status === 200) {
        const viewDetail = cardDetail.entity;
        this.savecarddetails.controls["username"].setValue(viewDetail.username);
        this.savecarddetails.controls["cardnumber"].setValue(
          viewDetail.last4digit
        );
        this.savecarddetails.controls["type"].setValue(viewDetail.type);
        this.savecarddetails.controls["expirymonth"].setValue(
          viewDetail.expirymonth
        );
        this.savecarddetails.controls["expiryyear"].setValue(
          viewDetail.expiryyear
        );
        this.savecarddetails.controls["firstname"].setValue(
          viewDetail.firstName
        );
        this.savecarddetails.controls["lastname"].setValue(viewDetail.lastName);
        this.savecarddetails.controls["cvv"].setValue(viewDetail.cvv);
        this.savecarddetails.controls["countryId"].setValue(
          viewDetail.country.id
        );
        if (viewDetail.country.id && viewDetail.country.id === "101") {
          this.ziplength = 6;
          this.zipmask = "000000";
          this.ziplabel = "Pin code";
        } else if (viewDetail.country.id && viewDetail.country.id === "231") {
          this.ziplength = 5;
          this.zipmask = "00000";
          this.ziplabel = "Zip code";
        }
        this.savecarddetails.controls["addressLine1"].setValue(
          viewDetail.addressLine1
        );
        this.savecarddetails.controls["addressLine2"].setValue(
          viewDetail.addressLine2
        );
        this.savecarddetails.controls["city"].setValue(viewDetail.cityName);
        this.savecarddetails.controls["zip"].setValue(viewDetail.zipCode);
        this.savecarddetails.controls["state"].setValue(viewDetail.state.id);
        this.savecarddetails.controls["timezone"].setValue(viewDetail.timezone);
        this.savecarddetails.controls["dob"].setValue(viewDetail.dob);
        this.savecarddetails.controls["primaryCard"].setValue(
          viewDetail.primaryCard
        );
        const date = new Date(viewDetail.dob);
        this.savecarddetails.patchValue({
          dob: {
            date: {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate(),
            },
          },
        });
        this.savecarddetails.controls["nickName"].setValue(viewDetail.nickName);
        this.savecarddetails.controls["ein"].setValue(viewDetail.ein);
        this.savecarddetails.controls["dialcode"].setValue(viewDetail.dialcode);
        if (viewDetail.dialcode && viewDetail.dialcode === "+1") {
          this.phonemask = "(000)000-0000";
        } else if (viewDetail.dialcode && viewDetail.dialcode === "+91") {
          this.phonemask = "00000-00000";
        }
        this.savecarddetails.controls["mobile"].setValue(viewDetail.mobile);
        this.savecarddetails.controls["mobileExtn"].setValue(
          viewDetail.mobileExtn
        );
        this.savecarddetails.controls["id"].setValue(viewDetail.id);
        this.getStateList(viewDetail.country.id);
        this.getCityList(viewDetail.state.id);
        this.savecarddetails.controls["cardnumber"].disable();
        this.savecarddetails.controls["expirymonth"].disable();
        this.savecarddetails.controls["expiryyear"].disable();
        this.savecarddetails.controls["cvv"].disable();
      }
    });
  }

  navigatetocalendar() {
    this.supportService.isAccept = false;
    localStorage.removeItem("pendingCreditCardOnboarding");
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "home-calendar",
    ]);
    this.supportService.subscriptionstatus.next("");
    this.modalRef.hide();
  }

  private isOnboardingCreditCardFlow(): boolean {
    return (
      this.supportService.isAccept === true ||
      localStorage.getItem("pendingCreditCardOnboarding") === "true"
    );
  }

  private hasActivePlan(): boolean {
    return !!(
      this.planList &&
      typeof this.planList === "object" &&
      !Array.isArray(this.planList) &&
      (this.planList.id || this.planList.status || this.planList.expiredDateStr)
    );
  }

  private showOnboardingThankYou(): void {
    this.errorMsg = "";
    this.clearMessage();
    this.getPlanList();
    this.isDisable = false;
    this.supportService.isAccept = false;
    localStorage.removeItem("pendingCreditCardOnboarding");
    this.modalRef = this.modalService.show(
      this.confirmpopup,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  triggerPopup() {
    this.isDelete = true;
    const card = this.deleteCardDetails;
    let countryCode = "";
    if (
      this.deleteCardDetails &&
      this.deleteCardDetails.countryCode !== null &&
      this.deleteCardDetails.countryCode === "231"
    ) {
      countryCode = "US";
    } else {
      countryCode = "IN";
    }
    this.appservice.getaccesstoken(countryCode).subscribe((token) => {
      if (token && token["access_token"]) {
        this.appservice
          .deleteCard(card.cardRefId, token["access_token"])
          .subscribe(
            (res) => {
              this.removeCard(card);
            },
            (err) => {
              this.removeCard(card);
            }
          );
      }
    });
  }

  deleteCard(card) {
    if (card.primaryCard === false) {
      this.deleteCardDetails = card;
      this.modalRef = this.modalService.show(
        this.deletePopup,
        Object.assign(this.config, { class: "popup-center" })
      );
    } else {
      this.message = "";
      this.errorMsg = "Unable to delete primary card";
      this.clearMessage();
    }
  }

  removeCard(card) {
    this.appservice.removeCard(card.id).subscribe((detail: any) => {
      this.isDelete = false;
      if (detail.status.status === 200) {
        this.errorMsg = "";
        this.message = "Card Removed Successfully";
        this.isDelete = false;
        this.clearMessage();
        this.modalRef.hide();
        this.getCardList();
        this.addcard();
      }
      if (detail.status.status === 400) {
        this.message = "";
        this.errorMsg = "Unable to delete primary card";
        this.clearMessage();
        this.modalRef.hide();
        this.getCardList();
        // this.addcard();
      }
    });
  }

  savePlan() {
    if (!this.isOnboardingCreditCardFlow()) {
      this.errorMsg = "";
      this.message = "Card Saved Successfully";
      this.isDisable = false;
      this.clearMessage();
      return;
    }

    if (this.hasActivePlan()) {
      this.showOnboardingThankYou();
      return;
    }

    const params: any = {};
    params.testCenterId = localStorage.getItem("testCenterId").toString();
    const date = moment(new Date(), "DD-MM-YYYY").format("YYYY-MM-DD");
    const toDate = moment(new Date(), "DD-MM-YYYY")
      .add(60, "days")
      .format("YYYY-MM-DD");
    params.fromDate = date + " 00:00:00";
    params.toDate = toDate + " 00:00:00";
    params.fromDateStr = date;
    params.toDateStr = toDate;
    params.holdedOn = "";
    params.unholdedOn = "";
    params.validDays = 60;
    params.hold_active = "false";
    params.holdCreatedOn = "";
    params.status = "trail";
    this.appservice.addPlanList(params).subscribe(
      (data: any) => {
        if (data.status.status === 200) {
          this.showOnboardingThankYou();
        } else {
          this.isDisable = false;
        }
      },
      () => {
        this.isDisable = false;
      }
    );
  }

  clearMessage() {
    setTimeout(() => {
      this.message = "";
      this.errorMsg = "";
    }, 5000);
  }
}
